// import { useEffect, useState } from "react";
import { tokenLoader } from "../../../utils/auth";
import NotificationsEnabledAccountV2 from "../../../components/notifications/NotificationsEnabledAccountV2";
// import LicenseValidationNotificationService from "../../../services/sockets/notifications/LicenseValidationNotificationService";

function NotificationsV2() {
  const localStorageValues = tokenLoader();
  const token = localStorageValues.token;

  return <NotificationsEnabledAccountV2 token={token} />;
}

export default NotificationsV2;
